import { useQuery } from "react-query";

import { planApi } from "@/react/api/planApi";
import { usePriceTestingEnabled } from "@/react/hooks/experiments/usePriceTestingEnabled";

export interface UseFetchPlanProps {
  billingCurrency?: string;
  locale?: string;
  planId?: number;
  planTier?: string;
  planType?: string;
}

export const useFetchPlan = ({
  planTier = "",
  planId,
  billingCurrency = "",
  locale = "",
  planType = "",
}: UseFetchPlanProps) => {
  const shouldFetchPlan = Boolean(planTier || planId);
  const isPriceTestingEnabled = usePriceTestingEnabled();

  const {
    data: plan,
    isInitialLoading: isPlanLoading,
    error: errorFetchingPlan,
  } = useQuery({
    queryKey: [
      "plan",
      "fetch",
      planTier,
      planId,
      billingCurrency,
      locale,
      planType,
      isPriceTestingEnabled,
    ],
    queryFn: () =>
      planApi.fetch({
        tier: planTier,
        id: planId,
        billing_currency: billingCurrency,
        locale: locale,
        plan_type: planType,
        isPriceTestingEnabled,
      }),
    enabled: shouldFetchPlan,
  });

  return {
    plan,
    isPlanLoading,
    errorFetchingPlan,
  };
};
